import styled from 'styled-components';
import { CaptionBoldLUppercase, BodyBoldM } from '../../../styles/globals';
import { IThemeProvider, ITheme } from '../../../styles/theme';

export const StatisticsBoxCont = styled.div`
  position: relative;
  min-height: 296px;
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const StatHeaderCont = styled.div`
  position: relative;
  display: flex;
  ${({ theme }: IThemeProvider) => `
      padding: ${theme.layout.spacing.decy} ${theme.layout.spacing.centy} ${theme.layout.spacing.centy};
  `};
`;

export const FirstPlaceHead = styled(CaptionBoldLUppercase)`
  display: flex;
  flex: 2 1 80%;
  align-items: center;
  width: 100%;
  text-align: left;
  ${({ theme }: IThemeProvider) => `
     color: ${theme.colors.neutral.primary[80]};
  `};
  svg {
    height: 13.33px;
    margin: 0 0 0 10px;
  }
`;

export const ScoreHeader = styled(CaptionBoldLUppercase)`
  width: 100%;
  flex: 1 0 6rem;
  text-align: left;
  ${({ theme }: IThemeProvider) => `
     color: ${theme.colors.neutral.primary[80]};
  `};
`;

export const EmptyInfoCont = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  ${({ theme }: IThemeProvider) => `
     color: ${theme.colors.neutral.primary[80]};
  `};
`;

export const NoDataText = styled(CaptionBoldLUppercase)`
  width: 239px;
  text-align: center;
`;

export const ResultsCont = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

interface IResTile {
  theme: ITheme;
  status?: 'weak' | 'normal' | 'strong';
  isClickAvailable?: boolean;
}

const getTileColors = (tileStat: 'weak' | 'normal' | 'strong', theme: ITheme) => {
  switch (tileStat) {
    case 'weak':
      return `
      border: 2px solid ${theme.colors.accent.red[70]};
      `;
    case 'normal':
      return `
      border: 2px solid ${theme.colors.accent.blue[70]};
      `;
    case 'strong':
      return `
      border: 2px solid ${theme.colors.accent.green[70]};
      `;
    default:
      return `
      border: none;
      `;
  }
};

export const ResTile = styled.div<IResTile>`
  width: 100%;
  display: flex;
  height: 64px;
  border-radius: 8px;
  cursor: default;
  box-sizing: border-box;
  ${({ theme, status, isClickAvailable }: IResTile) => {
    const additonalStyles = status && getTileColors(status, theme);
    return `
     background: ${theme.colors.neutral.primary[0]};
     box-shadow: 0px 1px 1px ${theme.colors.neutral.primary[40]};
     margin: 0 0 ${theme.layout.spacing.centy} 0;
     padding: 0 ${theme.layout.spacing.centy};
     ${additonalStyles};
     ${
  isClickAvailable &&
       `
        cursor: pointer;
        &:hover {
          background: ${theme.colors.primary[10]};
          box-shadow: 0px 1px 1px ${theme.colors.neutral.primary[60]};
        }`
}
  `;
  }};
`;

export const NameCont = styled.div`
  flex: 2 1 80%;
  align-self: center;
`;

export const ScoreCont = styled.div`
  display: flex;
  flex: 1 0 6rem;
  align-items: center;
  justify-content: space-between;
`;

export const PercentageCont = styled.div`
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[100]};
    background: ${theme.colors.secondary[10]};
    border: 1px solid ${theme.colors.secondary[70]};
    margin: 0 0 0 ${theme.layout.spacing.mikro};
    padding: ${theme.layout.spacing.nano};
    border-radius: ${theme.layout.spacing.nano};
  `}
`;

export const ScoreValue = styled(BodyBoldM)`
  width: calc(100% / 3);
`;
